import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "./ClassOffers.css";
import { FaBook, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { motion } from "framer-motion";

const classData = [
  {
    title: "Beginner (Day to day conversation)",
    // price: "2,400",
    color: "#8FA2E0",
    iconBg: "#00bcd4",
    textColor: "#000",
    modules: [
      {
        title: "Module 1: Everyday Communication Skills",
        points: [
          "Effective small talk and short conversations",
          "Expressing opinions politely",
          "Telling engaging personal stories",
          "Asking open-ended questions"
        ]
      },
      {
        title: "Module 2: Functional Grammar for Spoken English",
        points: [
          "Correcting common grammatical errors",
          "Using idioms and phrasal verbs",
          "Practicing tenses in real-time",
          "Adapting language for formal/informal contexts"
        ]
      },
      {
        title: "Module 3: Advanced Conversational Practice",
        points: [
          "Group discussions and debates",
          "Basics of public speaking",
          "Professional communication in work settings",
          "Mock interviews for confidence building"
        ]
      },
      {
        title: "Student Eligibility to enrol to the Course",
        points: [
          "Student can read & write basic English, however lacks ability or confidence even to make a sentence with 4 or 5 words.",
        ]
      }
    ]
  },
  {
    title: "Intermediate (Mid-career level, work & business)",
    // price: "6,000",
    color: " #FFB84D",
    iconBg: "#00bcd4",
    textColor: "#000",
    modules: [
      {
        title: "Module 1: Building Conversational Fluency",
        points: [
          "Connecting ideas smoothly",
          "Mastering spoken grammar",
          "Expressing a range of opinions",
          "Storytelling with vivid language"
        ]
      },
      {
        title: "Module 2: Expanding Your Verbal Toolkit",
        points: [
          "Idioms and phrasal verbs",
          "Topic-specific vocabulary",
          "Formal vs informal speech",
          "Detailed descriptions with adjectives/adverbs"
        ]
      },
      {
        title: "Module 3: Real-World Communication & Public Speaking",
        points: [
          "Group discussion skills",
          "Impromptu public speaking",
          "Mock interviews",
          "Giving and receiving feedback"
        ]
      },
      {
        title: "Module 4: Refining Your Spoken English",
        points: [
          "Listening for nuance & accents",
          "Pronunciation and stress patterns",
          "Spontaneous speaking drills",
          "Personalized practice for goals"
        ]
      },
      {
        title: "Student Eligibility to enrol to the Course",
        points: [
          "Student can read & write in English, can speak a few simple sentences however lacks the ability to engage in prolonged conversation. ",
          "Finds it difficult to converse appropriately in the professional/work environment on a day-to-day basis.",
        ]
      }
    ]
  },
  {
    title: "Advanced (Professional level)",
    color: "#4B5BB0",
    // price: "7,800",
    iconBg: "#00bcd4",
    textColor: "#ffffffff",
    modules: [
      {
        title: "Module 1: High-Impact Professional Communication",
        points: [
          "Persuasive presentations",
          "Negotiation and persuasion",
          "Code-switching between contexts",
          "Public speaking for professionals"
        ]
      },
      {
        title: "Module 2: Cross-Cultural & Interpersonal Communication",
        points: [
          "Global etiquette and cultural norms",
          "Managing difficult conversations",
          "Virtual communication mastery",
          "Collaborative dialogue"
        ]
      },
      {
        title: "Module 3: Specialized Vocabulary & Discourse",
        points: [
          "Legal, medical, and technical jargon",
          "Simplifying complex concepts",
          "Neutral accent for BPO roles"
        ]
      },
      {
        title: "Module 4: Professional Polish & Personal Branding",
        points: [
          "Vocal tone and modulation",
          "Body language confidence",
          "Realistic role-playing",
          "Building a credible brand"
        ]
      },
        {
        title: "Student Eligibility to enrol to the Course",
        points: [
          "Student is comfortable in simple day to day English, however lacks ability to engage in professional environment that involves in discussions of longer duration, like teaching, training, planning meeting, assessment meetings, etc. ",
          "This is suitable for professionals that work in roles requiring customer interaction, presentations, or corporate communication.",
        ]
      }
    ]
  },
   {
    title: "TOEFL",
    color: "#FF9900",
    iconBg: "#00bcd4",
    // price: "12,300",
    textColor: "#000",
    modules: [
      {
        title: "Module 1: Orientation & Test Overview",
        points: [
          "Introduction to TOEFL (iBT & PBT formats)",
          "Scoring system and section breakdown",
          "Registration & test-day procedures",
          "Study plan and time management"
        ]
      },
      {
        title: "Module 2: TOEFL Reading Section",
        points: [
          "Understanding academic passages",
          "Skimming & scanning techniques",
          "Vocabulary in context",
          "Main ideas vs supporting details",
          "Inference & reference questions",
          "Factual information & negative factual questions",
          "Practice with long academic texts",
          "Timed reading drills"
        ]
      },
      {
        title: "Module 3: TOEFL Listening Section",
        points: [
          "Types of listening tasks (lectures & conversations)",
          "Note-taking strategies",
          "Identifying main ideas & details",
           "Recognizing speaker attitude & purpose",
            "Understanding organization of information",
             "Practice with academic lectures & daily conversations",
              "Timed listening practice tests",
        ]
      },
      {
        title: "Module 4: TOEFL Speaking Section",
        points: [
          "Speaking question types (Independent & Integrated)",
          "Developing fluency and coherence",
          "Using transition words & academic vocabulary",
          "Independent speaking: expressing opinions clearly",
          "Integrated speaking: summarizing from reading + listening",
          "Pronunciation, stress, and intonation training",
          "Mock speaking tests with feedback"
        ]
      },
       {
        title: "Module 5: TOEFL Writing Section",
        points: [
          "Writing task types (Integrated & Independent)",
          "Essay structure (introduction, body, conclusion)",
          "Paraphrasing and summarizing techniques",
          "Organizing arguments logically",
          "Grammar & sentence variety improvement",
          "Academic vocabulary for essays",
          "Practice writing full essays under timed conditions",
          "Peer review and teacher feedback"
        ]
      },
       {
        title: "Module 6: Test-Taking Strategies & Practice",
        points: [
          "Time management in each section",
          "Guessing strategies (when unsure of answers)",
          "Avoiding common mistakes",
          "Building stamina for a 3-hour test",
          "Full-length TOEFL practice tests with review",
        ]
      },
       {
        title: "Module 7: Skill-Building Workshops (Optional)",
        points: [
          "Academic vocabulary building",
          "Critical thinking for reading & writing",
          "Listening to different English accents",
          "Speaking confidence & fluency drills",
          "Grammar refreshers",
        ]
      },
       {
        title: "By the end of the course, students should be able to:",
        points: [
          "Handle each section confidently",
          "Use effective strategies for higher scores",
          "Produce well-structured essays and fluent spoken responses",
          "Manage time during the actual test",
        ]
      }
    ]
  },
     {
    title: "IELTS",
    color: "#2B3990",
    // price: "12,300",
    iconBg: "#00bcd4",
    textColor: "#ffffffff",
    modules: [
      {
        title: "Module 1: Orientation & Test Overview",
        points: [
          "IELTS test types: Academic vs General Training",
          "Scoring system (Band descriptors explained)",
          "Section breakdown (Listening, Reading, Writing, Speaking)",
          "Test-day procedures & time management",
          "Diagnostic test (to assess current band level)"
        ]
      },
      {
        title: "Module 2: IELTS Listening Section",
        points: [
          "Test format: 4 parts (conversations + monologues)",
          "Listening for gist, detail, and purpose",
          "Common question types: Multiple choice, Matching, Sentence/summary completion, Note/table/diagram completion, Map/plan labelling",
          "Collaborative dialogue",
          "Note-taking strategies",
          "Practice with different accents (UK, US, Australian)",
          "Timed listening drills"
        ]
      },
      {
        title: "Module 3: IELTS Reading Section",
        points: [
          "Academic: 3 long texts (academic/scholarly)",
          "General Training: 3 sections (short texts, notices, workplace documents, longer text)",
          "Skimming & scanning techniques",
          "Recognizing paraphrasing & synonyms",
          "Common question types: o	True/False/Not Given, o	Matching headings, o	Matching information/features, o	Sentence completion, o	Summary/note/table completion, o	Multiple choice",
          "Time management for 60 minutes",
          "Timed reading practice (full passages)",
        ]
      },
      {
        title: "Module 4: IELTS Writing Section",
        points: [
          "Task 1 (Academic): Describe a graph, chart, table, process, or diagram",
          "Task 1 (General Training): Letter writing (formal, semi-formal, informal)",
          "Task 2 (Both): Essay – opinion, discussion, problem/solution, advantages/disadvantages",
          "Understanding task requirements",
          "Structuring responses (intro, body, conclusion)",
          "Paraphrasing & vocabulary usage",
          "Cohesion & coherence in writing",
          "Grammar & sentence variety",
          "Timed essay writing practice",
          "Peer & teacher feedback",
        ]
      },
       {
        title: "Module 5: IELTS Speaking Section",
        points: [
          "Format overview (3 parts): Part 1: Introduction & interview (familiar topics), Part 2: Long turn (cue card, 1–2 mins), Part 3: Discussion (abstract, opinion-based)",
          "Building fluency & coherence",
          "Vocabulary & idiomatic expressions",
          "Pronunciation practice (intonation, stress, clarity)",
          "Strategies for extending answers & avoiding silence",
          "Practice mock speaking interviews",
        ]
      },
      {
        title: "Module 6: Test-Taking Strategies & Practice",
        points: [
          "Time management across all sections",
          "Avoiding common mistakes (e.g., spelling in Listening, underlength in Writing)",
          "Guessing strategies",
          "Improving concentration & stamina for 2.5-hour test",
          "Full-length practice tests with review & feedback"
        ]
      },
      {
        title: "Module 7: Skill-Building Workshops (Optional)",
        points: [
          "Academic vocabulary for IELTS (Band 7+)",
          "Paraphrasing & synonym training (Reading/Writing)",
          "Accent listening practice (BBC, TED Talks, podcasts)",
          "Daily speaking fluency drills",
          "Grammar refreshers (common IELTS errors)"
        ]
      },
       {
        title: "By the end of the course, students should:",
        points: [
          "Be confident in all 4 sections of the test",
          "Know the types of questions & scoring criteria",
          "Be able to produce coherent essays & fluent spoken answers",
          "Have strategies to maximize their band score",
        ]
      }
    ]
  }
];



const ClassOffers = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const contentRefs = useRef([]);
  const [overflowCards, setOverflowCards] = useState({});

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  // Check overflow for each card
  useEffect(() => {
    const checkOverflow = () => {
      const newOverflow = {};
      contentRefs.current.forEach((ref, index) => {
        if (ref) {
          newOverflow[index] = ref.scrollHeight > 800;
        }
      });
      setOverflowCards(newOverflow);
    };
    
    // Wait for content to render
    setTimeout(checkOverflow, 100);
    window.addEventListener('resize', checkOverflow);
    
    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, []);

  const renderDetails = (modules, textColor) => (
    <motion.div
      className="modules-list"
      initial="hidden"
      animate="show"
      variants={{
        hidden: {},
        show: { transition: { staggerChildren: 0.15 } },
      }}
    >
      {modules.map((mod, idx) => (
        <motion.div
          key={idx}
          className="module-block"
          variants={{
            hidden: { opacity: 0, y: 20 },
            show: { opacity: 1, y: 0 },
          }}
          transition={{ duration: 0.5 }}
        >
          <h4 style={{ color: textColor }}>{mod.title}</h4>
          <ul>
            {mod.points.map((point, i) => (
              <motion.li
                key={i}
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
              >
                {point}
              </motion.li>
            ))}
          </ul>
        </motion.div>
      ))}
    </motion.div>
  );

  return (
    <div className="class-offers">
      <motion.h2
        className="section-title"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        Our Programs Crafted for You - Where Your Goals and Journey Find the Right Path
      </motion.h2>

      <motion.p
        className="section-subtitle"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.2 }}
      >
        At NewZeal Language Academy, every learner's journey is unique — and so are our courses.
      </motion.p>

      <div className="offers-grid">
        {classData.map((item, index) => {
          const isExpanded = expandedIndex === index;
          const hasOverflow = overflowCards[index];
          
          return (
            <motion.div
              key={index}
              className={`offer-card ${isExpanded ? 'expanded' : ''}`}
              style={{ background: item.color, color: item.textColor }}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              whileHover={{ scale: 1.03, boxShadow: "0px 10px 25px rgba(0,0,0,0.15)" }}
            >
              <motion.div
                className="offer-icon"
                style={{ backgroundColor: item.iconBg }}
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.6, delay: index * 0.3 }}
              >
                <FaBook size={20} color="#fff" />
              </motion.div>
              <h3 style={{ color: item.textColor }}>{item.title}</h3>
              {/* <h3 style={{ color: item.textColor }}>Fees: ₹{item.price}</h3> */}
              
              <div 
                ref={el => contentRefs.current[index] = el}
                className={`offer-content ${isExpanded ? 'expanded' : ''}`}
              >
                {renderDetails(item.modules, item.textColor)}
              </div>
              
              {hasOverflow && (
                <div className="read-more-container">
                  <button 
                    className="read-more-btn"
                    onClick={() => toggleExpand(index)}
                    style={{ 
                      color: item.textColor,
                      border: `1px solid ${item.textColor}`
                    }}
                  >
                    {isExpanded ? (
                      <>
                        <span>Show Less</span>
                        <FaChevronUp />
                      </>
                    ) : (
                      <>
                        <span>Show More</span>
                        <FaChevronDown />
                      </>
                    )}
                  </button>
                </div>
              )}
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default ClassOffers;